import React from "react";
import logo from "../../Assets/dhanushdhari_final_log.jpeg";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css";
import { Link,useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Logo & About */}
        <div className="footer-column">
          <h3 className="footer-logo"><img src={logo} alt="Dhanushdhari Logo"  width="50px"/><span>Dhanushdhari Developers</span></h3>
          <p className="footer-text">
            Building trust, quality homes, and landmark developments with
            excellence and innovation.
          </p>

          <div className="footer-social">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaLinkedinIn /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><a onClick={() =>{
            navigate("/");}}>Home</a></li>
            <li><a onClick={() =>{
            navigate("/#projects");}}>Projects</a></li>
            <li><a onClick={() =>{
            navigate("/#about");}}>About Us</a></li>
            <li><a onClick={() =>{
            navigate("/gallery");}}>Gallery</a></li>
            <li><a onClick={() =>{
            navigate("/#contact");}}>Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-column">
          <h4>Our Services</h4>
          <ul>
            <li><Link to="/services">Residential Projects</Link></li>
            <li><Link to="/services/commercial-spaces">Commercial Spaces</Link></li>
            <li><Link to="/services/property-consultation">Property Consultation</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-column">
          <h4>Contact Us</h4>
          <p><FaMapMarkerAlt /> Kolkata, West Bengal</p>
          <p><FaPhoneAlt /> +91 98765 43210</p>
          <p><FaEnvelope /> info@dhanushdhari.com</p>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>© 2025 Dhanushdhari Developers. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
